import { store } from '../state';
import { i18n } from '../i18n';
import { renderTemplate } from '../template-engine';
import { buildTemplateData, formatters } from '../template-utils';

// Импорт шаблонов (убедитесь, что пути совпадают с вашими)
import obsInfoTpl from '../templates/observation-info.html?raw';
import obsResultsTpl from '../templates/observation-results.html?raw';

const els = {
  observationDetails: document.getElementById('observation-details') as HTMLElement,
  obsTitle: document.getElementById('obs-title') as HTMLElement,
  tabInfo: document.getElementById('tab-info') as HTMLElement,
  tabResults: document.getElementById('tab-results') as HTMLElement,
  tabsNav: document.querySelector('.tabs') as HTMLElement, // Контейнер вкладок
};

function getParameterName(code: string): string {
  const param = store.getState().parametersDict.find(p => p.code === code);
  return param ? param.name : code; // Если не найдено, возвращаем сам код
}

function getLabName(labId: string | null | undefined): string {
  if (!labId) return 'Н/Д';
  const lab = store.getState().labsDict.find(l => l.id === labId);
  return lab ? lab.name : labId; // Если не найдено, возвращаем ID как fallback
}

function prepareSamplesData(samples: any[]): any[] {
  return samples.map(s => {
    const insituResults = (s.insitu_results || []).map((r: any) => ({
      parameter: getParameterName(r.parameter || '—'),
      value: r.value !== null && r.value !== undefined ? r.value : '—',
      details: escapeHtml(r.instrument || '—')
    }));

    const labResults = (s.lab_results || []).map((r: any) => ({
      parameter: getParameterName(r.parameter || '—'),
      value: r.value !== null && r.value !== undefined ? r.value : '—',
      details: getLabName(r.lab)
    }));

    return {
      title: s.sample_num ? `Проба №${escapeHtml(s.sample_num)}` : 'Проба (без номера)',
      descHtml: s.description ? ` <span class="sample-desc">(${escapeHtml(s.description)})</span>` : '',
      hasResults: insituResults.length > 0 || labResults.length > 0,
      insituResults,
      labResults
    };
  });
}


function renderInfoPart(obs: any): void {
  console.log('renderInfoParts');
  els.obsTitle.textContent = obs.num 
    ? i18n.t('ui.point_prefix', { num: obs.num }) 
    : i18n.t('ui.point_id', { id: obs.id.substring(0, 8) });

  // Рендерим вкладку "Инфо"
/*  const infoData = {
    name: obs.num || i18n.t('ui.unnamed'),
    date: obs.date, // замените на реальное поле даты
    traverseName: obs.traverse?.name || i18n.t('ui.unknown'),
    vesselName: obs.traverse?.vessel?.name || i18n.t('ui.unknown'),
    expeditionName: obs.traverse?.expedition?.name || i18n.t('ui.unknown'),
    siteName: obs.site?.name || i18n.t('ui.not_specified'),
    coords: { 
      key: 'latitude', 
      format: () => (obs.latitude != null && obs.longitude != null)
        ? `${Number(obs.latitude).toFixed(5)}, ${Number(obs.longitude).toFixed(5)}`
        : i18n.t('ui.unknown')
    },
    description: obs.description || i18n.t('ui.not_specified')
  };*/
  const infoData = buildTemplateData(
    obs,
    {
      expName: { key: 'traverse.expedition.name', fallback: i18n.t('ui.unknown') },
      vesselName: { key: 'traverse.vessel.name', fallback: i18n.t('ui.unknown') },
      siteName: { key: 'site.name', fallback: obs.site ? i18n.t('ui.unnamed') : i18n.t('ui.unassigned') },
      datetime: { key: 'time_start', format: formatters.datetime },
      coords: { 
        key: 'latitude', 
        format: () => (obs.latitude != null && obs.longitude != null)
          ? `${Number(obs.latitude).toFixed(5)}, ${Number(obs.longitude).toFixed(5)}`
          : i18n.t('ui.unknown')
      },
      description: { key: 'description', fallback: i18n.t('ui.no_desc') },
    },
    {
      i18n: {
        info: {
          expedition: i18n.t('info.expedition'),
          vessel: i18n.t('info.vessel'),
          site: i18n.t('info.site'),
          datetime: i18n.t('info.datetime'),
          coordinates: i18n.t('info.coordinates'),
          description: i18n.t('info.description')
        }
      }
    }
  );

  console.log('data is ', infoData);
  els.tabInfo.innerHTML = renderTemplate(obsInfoTpl, infoData);
}

function renderSamplesPart(insituSamples: any[], labSamples: any[]): void {
  const allSamplesMap = new Map();
  
  (insituSamples || []).forEach(s => {
    allSamplesMap.set(s.id, { ...s, lab_results: [] });
  });
  
  (labSamples || []).forEach(s => {
    if (allSamplesMap.has(s.id)) {
      allSamplesMap.get(s.id).lab_results = s.lab_results || [];
    } else {
      allSamplesMap.set(s.id, { ...s, insitu_results: [] });
    }
  });

  const mergedSamples = Array.from(allSamplesMap.values());

  console.log('renderSamplesPart');

  const resultsData = {
    hasSamples: mergedSamples.length > 0,
    samples: prepareSamplesData(mergedSamples),
    emptyMessage: i18n.t('samples.no_results_combined') || 'Нет результатов анализов.',
    i18n: {
      table: {
        parameter: i18n.t('table.parameter'),
        value: i18n.t('table.value'),
        details: i18n.t('table.details')
      },
      samples: {
        no_results: i18n.t('samples.no_results')
      }
    }
  };

  console.log('data is ', resultsData);

  els.tabResults.innerHTML = renderTemplate(obsResultsTpl, resultsData);
}

export function renderObservationPanel(state: any): void {
  console.log('renderObservationPanel');
  const obs = state.selectedObservation;
  if (!obs) return;
  els.observationDetails.style.display = 'block';
  els.tabsNav.style.display = 'flex'; // Показываем вкладки только для точки
  renderInfoPart(obs);
  renderSamplesPart(state.insituSamples, state.labSamples);
}

export function initObservationPanelListeners(): void {
  // Делегирование кликов по вкладкам
  els.tabsNav?.addEventListener('click', (e) => {
    const btn = (e.target as HTMLElement).closest('.tab-btn') as HTMLButtonElement;
    if (!btn) return;

    const tabId = btn.dataset.tab;
    if (!tabId) return;

    // Переключаем активный класс у кнопок
    els.tabsNav.querySelectorAll('.tab-btn').forEach(b => {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-selected', 'true');

    // Переключаем видимость контента
    document.querySelectorAll('.tab-content').forEach(content => {
      content.classList.remove('active');
    });
    const targetContent = document.getElementById(`tab-${tabId}`);
    if (targetContent) targetContent.classList.add('active');
  });
}

export function hideObservationPanel(): void {
  console.log('hideObservationPanel');
  els.observationDetails.style.display = 'none';
  els.tabsNav.style.display = 'none';
}

const escapeHtml = (str: string | undefined | null): string => {
  if (str == null) return '';
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
};

